import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import PasswordInput from "./PasswordInput";
import { Label } from "./ui/label";
import { Button } from "./ui/button";

export default function ChangePasswordCard() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Le nuove password non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Password aggiornata");
      setCur(""); setPw(""); setPw2(""); setOpen(false);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="ga-card p-5" data-testid="change-password-card">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1.5"><KeyRound className="w-3.5 h-3.5" /> Sicurezza account</div>
          <div className="mt-1 text-sm text-slate-600">Rinnova la password del tuo account quando vuoi.</div>
        </div>
        <Button type="button" variant="outline" className="rounded-full" onClick={() => setOpen(v => !v)} data-testid="change-password-toggle">{open ? "Annulla" : "Rinnova password"}</Button>
      </div>
      {open && (
        <form onSubmit={submit} className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3 items-end" data-testid="change-password-form">
          <div><Label>Password attuale</Label><PasswordInput required value={cur} onChange={e => setCur(e.target.value)} testId="current-password-input" autoComplete="current-password" /></div>
          <div><Label>Nuova password (min 6)</Label><PasswordInput required minLength={6} value={pw} onChange={e => setPw(e.target.value)} testId="new-password-input" autoComplete="new-password" /></div>
          <div><Label>Conferma nuova password</Label><PasswordInput required minLength={6} value={pw2} onChange={e => setPw2(e.target.value)} testId="confirm-new-password-input" autoComplete="new-password" /></div>
          <Button type="submit" disabled={busy} className="ga-btn-primary rounded-full sm:col-span-3 sm:justify-self-start" data-testid="change-password-submit">{busy ? "Salvataggio..." : "Salva nuova password"}</Button>
        </form>
      )}
    </div>
  );
}
